import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";

import useStyles from "./FmSlider.style";

type markType = { value: number; label: string };

interface FmSliderProps {
    sliderMarks: markType[];
    activeMark: number;
    setActiveMark: (mark: number) => void;
}

const FmSlider = ({ sliderMarks, activeMark, setActiveMark }: FmSliderProps) => {
    const classes = useStyles();

    const [sliderMarksDataAdjusted, setSliderMarksDataAdjusted] = useState<markType[]>([]);

    useEffect(() => {
        setSliderMarksDataAdjusted(
            sliderMarks.map((mark) => ({
                value: (mark.value - 1) * 33,
                label: mark.label,
            }))
        );
    }, [sliderMarks]);

    function valuetext(value: number) {
        return `${value}`;
    }

    function valueLabelFormat(value: number) {
        return sliderMarks.findIndex((mark) => mark.value === value) + 1;
    }

    const handleChange = (event: Event, newValue: number | number[]) => {
        const newValueAdjusted = (newValue as number) / 33 + 1;
        setActiveMark(newValueAdjusted);
    };

    return (
        <Box className={classes.box}>
            <Slider
                aria-label='Restricted values'
                value={(activeMark - 1) * 33}
                valueLabelFormat={valueLabelFormat}
                getAriaValueText={valuetext}
                valueLabelDisplay='on'
                step={null}
                marks={sliderMarksDataAdjusted}
                onChange={handleChange}
            />
        </Box>
    );
};

export default FmSlider;
